import { ComponentSingleStyleConfig } from '@chakra-ui/react';

export enum BtnVariant {
  SOLID = 'solid',
  OUTLINE = 'outline',
}

const Button: ComponentSingleStyleConfig = {
  baseStyle: {
    color: 'white',
    fontWeight: 'bold',
    fontSize: 'md',
    _focus: {
      boxShadow: 'unset',
    },
  },
  sizes: {
    sm: {},
    md: {},
    lg: {},
    xs: {},
  },
  variants: {
    [BtnVariant.OUTLINE]: {
      bg: 'transparent',
      borderColor: 'wsBlack',
      _hover: {
        bgColor: 'wsBlack',
        color: 'white',
      },
      _active: {
        bgColor: 'wsGray.400',
        color: 'white',
      },
      _focus: {
        boxShadow: 'unset',
      },
    },
    [BtnVariant.SOLID]: {
      bgColor: 'wsBlack',
      _hover: {
        bgColor: 'wsBlack',
      },
      _active: {
        bgColor: 'wsGray.400',
      },
      _focus: {
        boxShadow: 'unset',
      },
    },
  },
};

export default Button;
